import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "animated-icon"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#animated-icon" }),
  /*#__PURE__*/_createTextVNode(" Animated Icon ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Add "),
  /*#__PURE__*/_createElementVNode("code", null, ".accordion-icon-toggle"),
  /*#__PURE__*/_createTextVNode(" class to add toggle based animated icon in header: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = {
  class: "accordion accordion-icon-toggle",
  id: "kt_accordion_2"
}
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = {
  class: "accordion-header py-3 d-flex",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_1"
}
const _hoisted_9 = { class: "accordion-icon" }
const _hoisted_10 = { class: "svg-icon svg-icon-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " Accordion Item #1 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_2_item_1",
  class: "fs-5 collapse show ps-10",
  "data-bs-parent": "#kt_accordion_2"
}, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ", -1)
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_2_2"
}
const _hoisted_15 = { class: "accordion-icon" }
const _hoisted_16 = { class: "svg-icon svg-icon-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " Accordion Item #2 ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_2_item_2_2",
  class: "collapse fs-5 ps-10",
  "data-bs-parent": "#kt_accordion_2"
}, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ", -1)
const _hoisted_19 = { class: "mb-5" }
const _hoisted_20 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_3_3"
}
const _hoisted_21 = { class: "accordion-icon" }
const _hoisted_22 = { class: "svg-icon svg-icon-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " Accordion Item #3 ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_2_item_3_3",
  class: "collapse fs-5 ps-10",
  "data-bs-parent": "#kt_accordion_2"
}, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ", -1)
const _hoisted_25 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                ])
              ]),
              _hoisted_11
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                ])
              ]),
              _hoisted_17
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                ])
              ]),
              _hoisted_23
            ]),
            _hoisted_24
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<!--begin::Accordion-->
        <div class="accordion accordion-icon-toggle" id="kt_accordion_2_2">
          <!--begin::Item-->
          <div class="mb-5">
            <!--begin::Header-->
            <div
              class="accordion-header py-3 d-flex"
              data-bs-toggle="collapse"
              data-bs-target="#kt_accordion_2_item_1"
            >
              <span class="accordion-icon"
                ><span class="svg-icon svg-icon-4"><svg>...</svg></span></span
              >
              <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
                The best way to quick start business
              </h3>
            </div>
            <!--end::Header-->

            <!--begin::Body-->
            <div
              id="kt_accordion_2_item_1_1"
              class="fs-5 collapse show ps-10"
              data-bs-parent="#kt_accordion_2"
            >
              ...
            </div>
            <!--end::Body-->
          </div>
          <!--end::Item-->

          <!--begin::Item-->
          <div class="mb-5">
            <!--begin::Header-->
            <div
              class="accordion-header py-3 d-flex collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#kt_accordion_2_item_2"
            >
              <span class="accordion-icon"
                ><span class="svg-icon svg-icon-4"><svg>...</svg></span></span
              >
              <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
                How To Create Channel ?
              </h3>
            </div>
            <!--end::Header-->

            <!--begin::Body-->
            <div
              id="kt_accordion_2_item_2"
              class="collapse fs-5 ps-10"
              data-bs-parent="#kt_accordion_2"
            >
              ...
            </div>
            <!--end::Body-->
          </div>
          <!--end::Item-->

          <!--begin::Item-->
          <div class="mb-5">
            <!--begin::Header-->
            <div
              class="accordion-header py-3 d-flex collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#kt_accordion_2_item_3"
            >
              <span class="accordion-icon"
                ><span class="svg-icon svg-icon-4"><svg>...</svg></span></span
              >
              <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
                What are the support terms & conditions ?
              </h3>
            </div>
            <!--end::Header-->

            <!--begin::Body-->
            <div
              id="kt_accordion_2_item_3"
              class="collapse fs-5 ps-10"
              data-bs-parent="#kt_accordion_2"
            >
              ...
            </div>
            <!--end::Body-->
          </div>
          <!--end::Item-->
        </div>
        <!--end::Accordion-->`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}